module.exports = __webpack_public_path__ + "img/emoji_11.d9b269f2.png";